<ng-container *ngIf="canSeeAuditLogs">
  <app-link [link]="'general.api_audit_log_table_dialog_button'" [icon]="'user'" (linkClicked)="showAuditLogs()"></app-link>
</ng-container>

<ng-template #auditLogTableDialog>
  <app-dialog-header [title]="'general.api_audit_log_table_dialog_title'"></app-dialog-header>
  <mat-dialog-content class="dialog-min-height">
    <app-loader [loading]="isLoading" [overlay]="true"></app-loader>
    <div [ngClass]="{'with-footer': utilService.isMobile}">
      <audit-log-table [pageData]="auditLogPage" [(page)]="auditPageNumber" (pageChange)="getAuditLogs()" [showEntityType]="true"></audit-log-table>
    </div>
  </mat-dialog-content>
  <app-dialog-footer></app-dialog-footer>
</ng-template>
